import React from 'react';
import Spinner from '@v2/shared/components/Spinner';

export default function CompanyReviewWidget() {
  return (
    <div className="stjr-review-carousel">
      <div className="text-center">
        <Spinner className="text-4xl" />
      </div>
    </div>
  );
}
